module.exports = __webpack_public_path__ + "images/icons/flags/US-6a695427.svg";